<div
  class="sidebar-group"
  [class.sidebar-group--open]="isOpen"
  [class.sidebar-group--collapsed]="collapsed">
  <button
    type="button"
    class="sidebar-group__trigger"
    (click)="onToggleClick()"
    [attr.aria-expanded]="isOpen">
    <span class="sidebar-group__indicator" aria-hidden="true"></span>

    <span class="sidebar-group__leading">
      <ng-content select="[menu-icon]"></ng-content>
    </span>

    <span class="sidebar-group__title">{{ title }}</span>

    <fa-icon
      [icon]="['fal', 'chevron-down']"
      class="sidebar-group__chevron"
      [class.sidebar-group__chevron--open]="isOpen">
    </fa-icon>
  </button>

  <div class="sidebar-group__panel" [class.sidebar-group__panel--open]="isOpen">
    <div class="sidebar-group__panel-inner">
      <ng-content select="[menu-content]"></ng-content>
    </div>
  </div>
</div>
